import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { InputField, SelectField, UploadImageField } from "@/components/Form";
import { Button, Image, ImageList, LinkIc } from "@/components/Elements";
import { SearchPinCode } from "@/features/misc/components";
import { useCreateAdvert } from "../hooks/useCreateAdvert";
import { FileModel, TextValueModel } from "@/types/common";
import { useAddAdvertViewQuery } from "../api/merchant";
import { AddAdvertViewModel } from "../types";
import { useEffect, useState } from "react";

export const CreateAdvertForm = () => {
  const distanceRadius = useSelector(
    (state: RootState) => state.login.userDetail.distanceRadius
  );
  const { data } = useAddAdvertViewQuery();
  const { categoryList, subCategoryList: allSubCategoryList } =
    data ?? ({} as AddAdvertViewModel);
  const [subCategoryList, setSubCategories] = useState<TextValueModel[]>([]);
  const {
    register,
    handleUploadImg,
    handleSubmit,
    handleDraft,
    handlePublish,
    watch,
    setValue,
    formState,
  } = useCreateAdvert();
  const { files, location, categoryId } = watch();

  useEffect(() => {
    let subCategoryList: TextValueModel[] = [];
    if (categoryId && allSubCategoryList) {
      subCategoryList = allSubCategoryList.filter(
        (c) => c.parentId == categoryId
      );
    }
    setSubCategories(subCategoryList);
    setValue("subCategoryId", undefined);
  }, [allSubCategoryList, categoryId]);

  return (
    <>
      <div className="p-0 mt-[10px] pb-[10px]">
        <div>
          <InputField
            type="text"
            placeholder="Search Description from AI"
            registration={register("prompt")}
          />
        </div>
        <div className="maz-h-[45%]">
          <InputField
            type="text"
            placeholder="Write something here..."
            registration={register("description")}
            error={formState.errors["description"]}
            className="text-[20px]"
          />
        </div>
        <div className="p-[17px] border-b border-b-[#d3d3d3]">
          <UploadImageField name="file" setValue={handleUploadImg}>
            <div className="flex">
              <Image src="add-image.png" className="w-[25px] h-[25px]" />
              <div className="text-[15px] ml-4 text-center">
                Add Image/Video
              </div>
            </div>
          </UploadImageField>
          {files && (
            <ImageList
              files={files}
              handleChange={(value: FileModel[]) => setValue("files", value)}
              showRemove
            />
          )}
        </div>
        <SelectField
          registration={register("categoryId")}
          className="text-[20px]"
          label="Category"
          options={categoryList}
        />
        <SelectField
          registration={register("subCategoryId")}
          className="text-[20px]"
          label="Sub-Category"
          options={subCategoryList}
        />
        <InputField
          type="text"
          placeholder="Price"
          registration={register("price")}
          error={formState.errors["price"]}
        />
        <InputField
          type="text"
          placeholder="Discount"
          registration={register("discount")}
          error={formState.errors["discount"]}
        />
        <div className="p-[17px] border-b border-b-[#d3d3d3]">
          <SearchPinCode
            location={location}
            onChange={setValue}
            radius={distanceRadius}
            showAddress
          >
            <Image src="add-location.png" className="w-[25px] h-[25px]" />
            <div className="text-[15px] ml-4 text-center">Add Location</div>
          </SearchPinCode>
        </div>
        <div className="p-[17px]">
          <div className="flex items-center">
            <LinkIc className="w-[25px] h-[25px] text-[#ff9f33]" />
            <InputField
              type="text"
              placeholder="Instagram/Youtube Link(s)"
              registration={register("externalLinks")}
              className="ml-[20px]"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        <Button onClick={handleSubmit(handleDraft)} className="w-[49%]">
          Save as draft
        </Button>
        <Button onClick={handleSubmit(handlePublish)} className="w-[49%]">
          Publish
        </Button>
      </div>
    </>
  );
};
